export const BREVO_EVENT = {
  MUSIC_UPLOADED: 'MUSIC UPLOADED',
  CHECKLIST_COMPLETED: 'CHECK-LIST ONBOARDING PRODUCT COMPLETED',
  PLAYLIST_CREATED: 'PLAYLIST CREATED',
  PROGRAM_CREATED: 'PROGRAM CREATED',
  TIME_SLOT_CREATED: 'TIME SLOT CREATED',
  BREAK_CREATED: 'BREAK CREATED',
  RADIO_STARTED: 'RADIO STARTED',
};
